import axios from "axios";

// import TopBar from '../../components/common/topBar/TopBar.vue';
const TopBar = () => import("../../components/common/topBar/TopBar.vue");
const PDF = () => import("../../components/common/pdf/Index.vue");

//按需加载
import {
  //getBimDataBankCategoryList,
  getBimDatabankCommonCategoryList,
  deleteBimDatabankCommonCategory,
  getBimDataBankDataPage,
  deleteBimDataBankData,
  getBimDataBankCategoryTreeNew,
  getBimDataBankCategoryPC,
  getBimDataBankCategoryCC,
} from "../../api/api";
import md5 from "js-md5";
let recusionLevel = 0; // 判断递归的层次。

let homeBtnItem = {
  parentId: 0,
  text: "首页",
  id: -1,
};
let nowProjectId;
export default {
  name: "BimDatabank",
  components: {
    TopBar,
    PDF,
  },
  data() {
    return {
      keywords: "",
      condition: "",
      activeNames: ["1", "2"],
      currentPage: 1,
      categoryList: [], // 所有分类列表。
      categoryBtnList: [], //顶部导航栏下方的分类按钮组，按sort字段倒序排列，取前八个。
      currentCategoryPath: [], //当前用户选择的资料目录路径，第一级目录排在最前面。
      categoryOptions: [], // 查询框前的分类选择下拉框选项。
      commonCategoryList: [], //常用目录列表。
      directotryData: [], // 目录树。
      defaultProps: {
        children: "copyChildren",
        label: "text",
        isLeaf: "leaf",
      },
      categoryPanelShow: false,
      categoryPanelData: [], //展开的第四级目录的总数据。
      currentPage: 1, //当前分页展示页码。
      pageSize: 20, //当前表格每页展示的数据条数。
      totalRows: 0, //数据总条数。
      checkedArr: [],
      dDataList: [], // 当前分类下的资料项列表。
      currentPanelActiveCateId: 0,
      checkedAll: false,
      isAscend: false, // 现在这个isAscend就只针对列表项的createdTime字段，值为false表示是倒序，为true表示是升序。
      getDataType: 1, // 记录最近一次获取资料项数据的方式，为1表示是通过目录获取的，为2表示是通过查询的。
      dialogVisible: false,
      fileList: [],
      pdfSrc: "",
      sourceToken: null,
    };
  },
  mounted() {
    let that = this;

    nowProjectId = parseInt(window.sessionStorage.getItem("nowProjectId"));
    // 获取到顶部导航栏下方的前八个根分类。
    // let getCLData = {
    // 	projectId: nowProjectId,
    // 	pid: 0,
    // 	sortField: 'sort',
    // 	sortOrder: 'descend',
    // };
    // //console.log(JSON.parse(JSON.stringify(getCLData)));
    // getBimDataBankCategoryList(getCLData).then(res => {
    // 	// console.log(JSON.parse(JSON.stringify(res.data.data)));
    // 	// console.log(1111111111111112);
    // 	if (res.data.success && res.data.data.length > 0) {
    // 		this.categoryList=res.data.data;
    // 		// console.log(JSON.parse(JSON.stringify(this.categoryList)));
    // 		that.categoryBtnList = res.data.data.filter(item=>item.pId===0).slice(0, 8);
    // 		let temparr=that.categoryBtnList.slice(0);
    // 		// console.log(JSON.parse(JSON.stringify(that.categoryBtnList)));
    // 		that.categoryBtnList.unshift(homeBtnItem);
    // 		//console.log(JSON.parse(JSON.stringify(that.categoryBtnList)));
    // 		that.categoryOptions = [{
    // 			pId: 0,
    // 			name: "所有分类",
    // 			id: 0
    // 		}, ...temparr];
    // 		// console.log(JSON.parse(JSON.stringify(that.categoryOptions)));
    // 		// console.log(4444444444444);
    // 	}else{
    // 		that.categoryOptions = [{
    // 			pId: 0,
    // 			name: "所有分类",
    // 			id: 0
    // 		}];
    // 	}
    // })

    // let getCTreeData = {
    // 	projectId: nowProjectId,
    // };
    this.getBimDataBankCategoryTreeNew().then((res) => {
      if (res.data.success && res.data.data.length > 0) {
        let tempData = res.data.data.map((item) => {
          let tempObj = { ...item };
          tempObj.children = [];
          return tempObj;
        });
        this.categoryBtnList = tempData
          .slice(0)
          .filter((item) => item.parentId === 0)
          .slice(0, 8);
        let temparr = this.categoryBtnList.slice(0);
        this.categoryBtnList.unshift(homeBtnItem);
        this.categoryOptions = [
          {
            parentId: 0,
            text: "所有分类",
            id: 0,
          },
          ...temparr,
        ];
        this.directotryData = res.data.data;
      } else {
        this.categoryOptions = [
          {
            parentId: 0,
            name: "所有分类",
            id: 0,
          },
        ];
        this.directotryData = [];
      }
    });
    // getBimDataBankCategoryTreeNew({
    //   projectId: nowProjectId,
    //   pid: 0,
    // }).then((res) => {
    //   console.log("ZHANG", res);
    //   if (res.data.success && res.data.data.length > 0) {
    //     let tempData = res.data.data.map((item) => {
    //       let tempObj = { ...item };
    //       tempObj.children = [];
    //       return tempObj;
    //     });

    //     that.categoryBtnList = tempData
    //       .slice(0)
    //       .filter((item) => item.parentId === 0)
    //       .slice(0, 8);
    //     let temparr = that.categoryBtnList.slice(0);

    //     that.categoryBtnList.unshift(homeBtnItem);

    //     that.categoryOptions = [
    //       {
    //         parentId: 0,
    //         text: "所有分类",
    //         id: 0,
    //       },
    //       ...temparr,
    //     ];

    //     that.directotryData = res.data.data;
    //     // 遍历。
    //     that.directotryData.forEach((item) => {
    //       // 第一层
    //       item.showNewCTab = false; // 点击第一级，不展示新的分类面板。
    //       item.copyChildren = item.children.slice(0);
    //       if (item.copyChildren.length > 0) {
    //         item.copyChildren.forEach((item2) => {
    //           item2.showNewCTab = false; // 点击第二级，不展示新的分类面板。
    //           item2.copyChildren = item2.children.slice(0);
    //           // 第二层
    //           if (item2.children.length > 0) {
    //             item2.copyChildren.forEach((item3) => {
    //               // 第三层 不论是否有子节点，都不应该在左侧树进一步展开，三级以下的树节点在右侧面板中展开时，从item3.children属性中读取，而非从item3.copyChildren中读取。
    //               item3.copyChildren = []; // 避免左侧树还可以继续展开第四层。
    //               if (item3.children.length > 0) {
    //                 item3.showNewCTab = true;
    //                 item3.children.forEach((item4) => {
    //                   //初始化点击此分类时，弹出面板里的数据。
    //                   if (item4.id && item4.id > 0) {
    //                     //console.log(JSON.parse(JSON.stringify(item)));
    //                     getBimDataBankCategoryPC({
    //                       projectId: nowProjectId,
    //                       id: item4.id,
    //                     }).then((res) => {
    //                       if (res.data.success) {
    //                         // 多级目录面板里的导航去掉首页及前三级目录。
    //                         item4.panelCatePathArr = [
    //                           homeBtnItem,
    //                           ...res.data.data,
    //                         ].slice(4);
    //                         // console.log(88888888);
    //                         item4.showListData = item4.children.slice(0);
    //                         // item4.panelCatePathArr.forEach(item5=>{
    //                         // 	item5.children=item4.children.slice(0);
    //                         // })
    //                         // console.log(111);
    //                         // console.log(JSON.parse(JSON.stringify(item4.panelCatePathArr)));
    //                         // console.log(JSON.parse(JSON.stringify(item4.showListData)));
    //                         // console.log(222);
    //                       } else {
    //                         // that.$message({
    //                         // 	message: '请求失败，请稍后再点击一次该目录。',
    //                         // 	type: 'success',
    //                         // 	offset: 100,
    //                         // 	showClose: true,
    //                         // 	duration: 1600,
    //                         // });
    //                         console.log("请求失败，未获取到四级目录数据。");
    //                       }
    //                     });
    //                   }
    //                 });
    //               } else {
    //                 item3.showNewCTab = false;
    //               }
    //             });
    //           }
    //           item2.children = []; //清除多余数据。
    //         });
    //       }
    //       item.children = []; // 清除多余数据。
    //     });
    //   } else {
    //     that.categoryOptions = [
    //       {
    //         parentId: 0,
    //         name: "所有分类",
    //         id: 0,
    //       },
    //     ];

    //     that.directotryData = [];
    //   }
    // });
    this.currentCategoryPath.push(homeBtnItem);

    // 获取到常用目录列表。
    this.getCCList();

    // 获取到当前分类下的所有资料项。
  },
  methods: {
    // 跳转链接
    // type为1，表示跳往新增资料项页面；type为2，表示跳往编辑资料项页面。
    jumpTo(name, params) {
      // console.log(JSON.parse(JSON.stringify(params)));
      // console.log(111)
      this.$router.push({ name: name, params: params });
    },
    newJumpTo(name, params) {
      const routeUrl = this.$router.resolve({ name: name, params: params });
      window.open(routeUrl.href, "_blank");
    },
    checkedChange() {
      if (this.checkedArr.length === this.dDataList.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
      // console.log(JSON.parse(JSON.stringify(this.checkedArr)));
    },
    checkedAllChange() {
      if (this.checkedAll) {
        let dataIds = this.dDataList.map((item) => item.id);
        this.checkedArr = dataIds;
      } else {
        this.checkedArr = [];
      }
    },
    // 分页页码数字变化。
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 获取常用目录列表。
    getCCList() {
      let that = this;
      let getCCLData = {
        projectId: nowProjectId,
        sortField: "createdTime",
        sortOrder: "ascend",
      };
      getBimDatabankCommonCategoryList(getCCLData).then((res) => {
        // console.log(JSON.parse(JSON.stringify(res.data.data)));
        // console.log(555555555);
        if (res.data.success && res.data.data.length > 0) {
          that.commonCategoryList = res.data.data;
        } else {
          that.commonCategoryList = [];
        }
      });
    },

    getBimDataBankCategoryTreeNew(pid = 0) {
      return new Promise((resolve, reject) => {
        getBimDataBankCategoryTreeNew({
          projectId: nowProjectId,
          pid: pid,
        })
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "查询失败",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          });
      });
    },
    loadNode(node, resolve) {
      this.categoryPanelShow = false;
      if (node.id != 0)
        this.getBimDataBankCategoryTreeNew(node.data.id).then((res) => {
          if (node.level == 2) {
            let newData = res.data.data.map((item) => {
              item.leaf = true;
              return item;
            });
            return resolve(newData);
          } else {
            return resolve(res.data.data);
          }
        });
    },

    viewDetails(item) {
      if (item.fileList.length == 1) {
        this.$refs.PDF.isShow = true;
        this.pdfSrc =
          process.env.VUE_APP_LOCAL_RESOURCES_PATH +
          item.fileList[0].filePath +
          "/" +
          item.fileList[0].fileObjectName;
      } else if (item.fileList.length > 1) {
        this.dialogVisible = true;
        this.fileList = item.fileList;
      } else {
        this.$message({
          message: "暂无附件",
          type: "warning",
          duration: 1500,
        });
      }
    },
    rowClick(item) {
      this.dialogVisible = false;
      this.$refs.PDF.isShow = true;

      this.pdfSrc =
        process.env.VUE_APP_LOCAL_RESOURCES_PATH +
        item.filePath +
        "/" +
        item.fileObjectName;
    },
    showMsg(msg) {
      if (msg != "") {
        this.$message({
          message: msg,
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    openWindow(url, title, w = "800", h = "600") {
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : screen.left;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : screen.top;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;
      const newWindow = window.open(
        this.processLinks(url),
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left,
        "_search"
      );

      if (window.focus) {
        newWindow.focus();
      }
    },
    processLinks(url) {
      let _foreignRootUrl = "http://172.16.52.130:8000",
        qualityUrl = url,
        partid,
        ut,
        tk,
        newUrl;
      ut = Date.parse(new Date());
      partid = qualityUrl.split("?")[1];
      tk = this.getMd5(ut);
      newUrl = `${_foreignRootUrl}/quality/deliver-cert?id=${partid}&tk=${tk}&ut=${ut}`;
      return newUrl;
    },
    getMd5(time) {
      var hash = md5("BIM" + "@" + time);
      return hash;
    },
    // 获取首页展示的资料项数据。
    initData(type, cateId) {
      let that = this;
      this.checkedArr = [];
      this.checkedAll = false;
      let getdData = {
        projectId: nowProjectId,
        pageSize: that.pageSize,
        sortField: "oldSort",
        // sortOrder: that.isAscend ? "ascend" : "descend",
        sortOrder: "ascend",
      };

      if (type) {
        that.getDataType = type; // 如果传了type，那就更新type。
        that.currentPage = 1; // 重置一下当前页为1，避免切换搜索项时页码过大导致查询不出数据。
      }
      getdData.pageNo = that.currentPage;
      // if (this.controller) {
      //   this.controller.abort();
      // }

      // this.controller = new AbortController();
      // getdData.
      if (this.sourceToken) {
        this.sourceToken.cancel("artificial");
      }
      this.sourceToken = axios.CancelToken.source();
      switch (this.getDataType) {
        case 1 /* 查询当前分类下资料项。 */:
          let categoryId = cateId
            ? cateId
            : this.currentCategoryPath[this.currentCategoryPath.length - 1].id;
          if (categoryId > 0) {
            getdData.directoryId = categoryId;
          }

          getBimDataBankDataPage(getdData, this.sourceToken)
            .then((res) => {
              if (res.data.success && res.data.data.rows.length > 0) {
                that.dDataList = res.data.data.rows;
                that.currentPage = res.data.data.pageNo;
                that.totalRows = res.data.data.totalRows;
              } else {
                that.dDataList = [];
                that.totalRows = 0;
                that.currentPage = 1;
              }
            })
            .catch((e) => {
              if (e.message != "artificial")
                this.$message({
                  message: "查询出错了，请稍后查询。",
                  type: "error",
                  offset: 100,
                  showClose: true,
                  duration: 1600,
                });
            });

          break;
        case 2 /* 查询当前搜索条件下的资料项。 */:
          if (that.keywords.trim() !== "" || that.condition > 0) {
            if (that.keywords.trim() !== "") {
              getdData.searchValue = that.keywords;
            }
            if (that.condition > 0) {
              getdData.directoryId = that.condition;
            }
            getBimDataBankDataPage(getdData, this.sourceToken)
              .then((res) => {
                if (res.data.success && res.data.data.rows.length > 0) {
                  that.dDataList = res.data.data.rows;
                  that.currentPage = res.data.data.pageNo;
                  that.totalRows = res.data.data.totalRows;
                } else {
                  that.dDataList = [];
                  that.totalRows = 0;
                  that.currentPage = 1;
                }

                // 顶部搜索框搜索数据时，不论是否选择了所有分类，都应该更新当前分类路径。
                if (that.condition > 0) {
                  getBimDataBankCategoryPC({
                    projectId: nowProjectId,
                    id: that.condition,
                  }).then((res) => {
                    if (res.data.success) {
                      that.currentCategoryPath = [
                        homeBtnItem,
                        ...res.data.data,
                      ];
                    } else {
                      console.log("更新首页当前分类失败。");
                    }
                  });
                } else {
                  that.currentCategoryPath = [homeBtnItem];
                  if (that.keywords.trim() === "") {
                    that.getDataType = 1; //切换为默认查找当前目录下的资料项。
                  }
                }
              })
              .catch((e) => {
                if (e.message != "artificial")
                  that.$message({
                    message: "查询出错了，请稍后查询。",
                    type: "success",
                    offset: 100,
                    showClose: true,
                    duration: 1600,
                  });
              });
          } else {
            that.$alert(
              "请先选择分类，或者输入您所要查询资料项的标题或备注里的关键字，再点击查询按钮进行查询哦~",
              "友情提示",
              {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {
                  that.getDataType = 1; //切换为默认查找当前目录下的资料项。
                },
              }
            );
          }
          break;
        default:
          break;
      }
    },

    // 判断导航栏下方的目录按钮是否可以点击。也用于判断常用目录的选项是否加上“current”样式。
    disableCategoryBtn(id) {
      // 如果当前用户选择的资料目录路径中的最后一级目录在顶部导航栏下方的分类按钮组里面，则禁用掉顶部导航栏下方的分类按钮组里面的该项，其实也可以理解为是一个选中样式。已选中的元素再次点击不会触发点击效果。
      let lastChooseCategory =
        this.currentCategoryPath[this.currentCategoryPath.length - 1];
      // let result=this.categoryBtnList.findIndex((item)=>{
      // 	//return item.id===lastChooseCategory.id;
      // 	return item.id===id;
      // })
      // console.log(id);
      // console.log(2222222222);

      if (lastChooseCategory && lastChooseCategory.id === id) {
        //console.log(lastChooseCategory.id);
        return true;
      } else {
        return false;
      }
    },
    // 更新当前分类路径。
    updateCurrentCategoryPath(type, item) {
      let that = this;
      switch (type) {
        case 1:
          //type为1表示是点击导航栏下方的目录按钮导致的当前分类路径更新。
          // console.log(JSON.parse(JSON.stringify(homeBtnItem)));
          // console.log(JSON.parse(JSON.stringify(item)));
          if (item.id !== -1) {
            this.currentCategoryPath = [homeBtnItem, item];
          } else {
            this.currentCategoryPath = [homeBtnItem]; //点击“首页”按钮则显示全部数据。
          }
          this.initData(1);
          break;
        case 2:
          //点击面包屑【网站地图】导致的当前分类路径更新。
          item++;
          this.currentCategoryPath = this.currentCategoryPath.slice(0, item);
          this.initData(1);
          break;
        case 3:
          //点击页面左侧折叠面板中的常用目录导致的分类路径更新。
          //遍历树，找到该常用目录的父级目录层级列表。
          // this.refreshDataByCateId(item.categoryId);
          break;
        default:
          break;
      }
      // console.log(item);
      // console.log(this.currentCategoryPath);
      // console.log(333);
    },
    //更新面板里的目录路径及展开的目录。
    //type为1表示是从导航地图中点击，type为2表示是从导航地图下方的目录链接列表中点击。
    async updatePanelCatePath(data, index, type) {
      let showListData;
      this.categoryPanelData[index].loading = true;
      if (data.id && data.id > 0) {
        if (type == 2) {
          this.categoryPanelData[index].panelCatePathArr.push(data);
        } else {
          let subscript, newPanelCatePathArr;
          console.log(this.categoryPanelData[index].panelCatePathArr);
          this.categoryPanelData[index].panelCatePathArr.find((item, i) => {
            if (data.id == item.id) {
              subscript = i;
            }
          });
          console.log(subscript);
          newPanelCatePathArr = this.categoryPanelData[
            index
          ].panelCatePathArr.slice(0, subscript + 1);
          this.categoryPanelData[index].panelCatePathArr = newPanelCatePathArr;
        }

        if (data.level && data.level >= 0) {
          this.refreshDataByCateId(data.id);
        } else {
          this.dDataList = [];
          this.totalRows = 0;
          this.currentPage = 1;
        }
        showListData = await this.getBimDataBankCategoryTreeNew(data.id);
        this.categoryPanelData[index].showListData = showListData.data.data;
        this.categoryPanelData[index].loading = false;
        // console.log(data, this.categoryPanelData[index], type);

        // getBimDataBankCategoryPC({ projectId: nowProjectId, id: data.id }).then(
        //   (res) => {
        //     if (res.data.success) {
        //       // 多级目录面板里的导航去掉首页及前三级目录。
        //       //that.$nextTick(()=>{
        //       that.categoryPanelData[index].panelCatePathArr = [
        //         homeBtnItem,
        //         ...res.data.data,
        //       ].slice(4);
        //       that.categoryPanelData[index].showListData = data.children.slice(
        //         0
        //       );
        //       //})
        //       if (type === 1) {
        //         getBimDataBankCategoryCC({
        //           projectId: nowProjectId,
        //           id: data.id,
        //         }).then((res2) => {
        //           //console.log(JSON.parse(JSON.stringify(res2)));
        //           //console.log(333);
        //           if (res2.data.success) {
        //             that.categoryPanelData[index].showListData =
        //               res2.data.data[0].children;
        //           }
        //           that.$forceUpdate();
        //         });
        //       } else if (type === 2) {
        //         that.currentPanelActiveCateId = data.id;
        //         that.$forceUpdate();
        //       }
        //       that.refreshDataByCateId(data.id);
        //       //that.$set(that.categoryPanelData[index],"panelCatePathArr",[homeBtnItem, ...res.data.data].slice(4));
        //       //Object.assign({},that.categoryPanelData[index],{panelCatePathArr:[homeBtnItem, ...res.data.data].slice(4)});
        //       //console.log(JSON.parse(JSON.stringify(that.categoryPanelData)));
        //       //console.log(88888888);
        //     } else {
        //       that.$message({
        //         message: "请求失败，请稍后再点击一次该目录。",
        //         type: "success",
        //         offset: 100,
        //         showClose: true,
        //         duration: 1600,
        //       });
        //     }
        //   }
        // );
      }
    },
    //点击目录获取所有父级目录，并刷新页面数据。
    refreshDataByCateId(cateId) {
      if (cateId && cateId > 0) {
        let that = this;
        //console.log(JSON.parse(JSON.stringify(item)));
        getBimDataBankCategoryPC({
          projectId: nowProjectId,
          id: cateId,
        }).then((res) => {
          if (res.data.success) {
            that.currentCategoryPath = [homeBtnItem, ...res.data.data];
          } else {
            that.$message({
              message: "请求失败，请稍后点击一次该目录。",
              type: "success",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          }
        });
        that.initData(1, cateId);
      } else {
        that.$message({
          message: "未获取到该分类的id，刷新数据失败。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    // 删除常用分类。
    deleteCommonCategory(id) {
      let that = this;
      this.$confirm("确定将该分类从常用分类列表中移除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 删除树节点
        //axios请求删除节点代码
        let dccData = {
          projectId: nowProjectId,
          id: id,
        };
        deleteBimDatabankCommonCategory(dccData).then((res) => {
          // console.log(JSON.parse(JSON.stringify(res)));
          // console.log(444444444444);
          if (res.data.success) {
            that.getCCList();
          } else {
            that.$alert(
              "将该分类设为非常用分类失败了，请再试一次吧~",
              "设置失败",
              {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {},
              }
            );
          }
        });
      });
    },
    handleChange(val) {
      // console.log(val);
    },
    handleNodeClick(data, node) {
      console.log(data.level);
      // this.refreshDataByCateId(data.id);
      if (data.level && data.level >= 0) {
        this.refreshDataByCateId(data.id);
      } else {
        this.dDataList = [];
        this.totalRows = 0;
        this.currentPage = 1;
      }
      if (node.level == 3) {
        this.getBimDataBankCategoryTreeNew(node.data.id).then((res) => {
          if (res.data.success) {
            // 多级目录面板里的导航去掉首页及前三级目录。
            let showListData;
            this.categoryPanelShow = true;
            let newData = [];
            res.data.data.forEach(async (item) => {
              item.panelCatePathArr = [{ ...item }];
              showListData = await this.getBimDataBankCategoryTreeNew(item.id);
              item.showListData = showListData.data.data;
              newData.push(item);
            });
            this.categoryPanelData = newData;
          } else {
            console.log("请求失败，未获取到四级目录数据。");
          }
        });
      }

      // if (data?.showNewCTab) {
      //   this.categoryPanelShow = true;
      //   this.categoryPanelData = data.children;
      // } else {
      //   this.categoryPanelShow = false;
      //   this.categoryPanelData = [];
      // }
    },
    getBimDataBankCategoryPC(id) {
      return new Promise((resolve, reject) => {
        getBimDataBankCategoryPC({
          projectId: nowProjectId,
          id: id,
        }).then((res) => {
          resolve(res);
        });
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.initData();
      //console.log(`当前页: ${val}`);
    },
    // 改变排序顺序。
    // changeSort(){
    // 	this.isAscend=!this.isAscend;
    // },
    deleteData() {
      let that = this;
      if (that.checkedArr.length > 0) {
        this.$confirm(
          "确定要删除所有已选中的资料项及其中的文件吗？",
          "确认提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确认删除",
            cancelButtonText: "取消删除",
          }
        )
          .then(() => {
            deleteBimDataBankData({ id: that.checkedArr }).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success) {
                that.initData();
              } else {
                that.$alert("删除失败了，请再试一次吧~", "删除失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          })
          .catch(function (err) {
            // console.log(err)
            that.$message({
              message: "已取消此次删除。",
              type: "success",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          });
      } else {
        that.$alert(
          "请先勾选您所要删除的资料项前方的复选框，再点击删除按钮哦~",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          }
        );
      }
    },
  },
  watch: {
    currentCategoryPath: function (newVal, oldVal) {
      setTimeout(() => {
        // this.initData();
      }, 100);
    },
  },
};
